export const SearchReducer = (state, action) => {
  switch (action.type) {
    case "LOADING_SEARCH_DATA":
      return {
        ...state,
        isLoading: true,
        initial: false,
      };
    case "GET_SEARCH_DATA":
      return {
        ...state,
        initial: false,
        isLoading: false,
        showPagination: action.count > action.results.length,
        totalCount: action.count,
        next: action.next,
        previous: action.previous,
        results: action.results,
      };
    case "CLEAR_SEARCH_DATA":
      return {
        ...state,
        initial: false,
        isLoading: false,
        showPagination: false,
        totalCount: 0,
        next: null,
        previous: null,
        results: [],
      };
    case "TOGGLE_SEARCH_DISPLAY":
      return {
        ...state,
        showPanelSearch: !state.showPanelSearch,
      };
    default:
      return state;
  }
};
